import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { SkoolCommunityInfo } from '../services/accountService';

interface SkoolCommunityCardProps {
  info: SkoolCommunityInfo;
}

const SkoolCommunityCard: React.FC<SkoolCommunityCardProps> = ({ info }) => {
  if (!info.showSkoolCommunity || !info.skoolCommunityUrl) {
    return null;
  }

  const handleOpenSkool = () => {
    window.open(info.skoolCommunityUrl!, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="dashboard-skool-card card" aria-label="Skool Community">
      <div className="dashboard-skool-card__content">
        <div className="dashboard-skool-card__icon" aria-hidden="true">
          <FontAwesomeIcon icon={faUsers} />
        </div>
        <div className="dashboard-skool-card__text">
          <h2>Skool Community</h2>
          <p>Join the WTI community on Skool.</p>
          <p className="dashboard-skool-card__hint">
            {info.openInNewTabHint || 'Open Skool Community in a new tab'}
          </p>
        </div>
        <button
          type="button"
          className="btn btn-primary dashboard-skool-card__button"
          onClick={handleOpenSkool}
        >
          Open Skool Community
        </button>
      </div>
    </section>
  );
};

export default SkoolCommunityCard;
